import { RegisteredEventName } from './events'

export interface Action<E extends string, T = any> {
  type: E
  payload?: T
}

export type CookieConsentRequestAction = Action<
  'cookieConsentRequest',
  {
    [serviceName: string]: boolean
  }
>

export type PollardAction = CookieConsentRequestAction | Action<string>

export function action<A extends PollardAction>({ type, payload }: A) {
  return {
    eventName: RegisteredEventName.action,
    data: {
      type,
      payload
    }
  }
}
